import get from "lodash/get";
import {
  postDashboardWebApi,
  putDashboardWebApi
} from "../../webapis/apiResource";
import { getAccessToken } from "../../util/storeHelper";
import { BEConfig } from "../../config/env";

import {
  resetResponseUpdateDetailsData,
  setAuthUserData,
  setToken
} from "./authConfig.action";
import {
  errorOnUserSide,
  handleFetchError,
  internalServerError
} from "../../util/errorHandler";
import { languageFromPathName } from "../../util";
import { ContextStorage } from "@/libs/contextStorage";
import { fetchAddressBook, fetchUserAndLoadData } from "./authConfig.action";
import {
  showLoadingIndicator,
  hideLoadingIndicator,
  showPageLoader,
  hidePageLoader
} from "./common.action";
import {
  API_ERROR,
  RESET_API_ERROR,
  API_NOTIFICATION_MSG,
  RESET_NOTIFICATION_MSG,
  LOGIN_SUCCESS,
  SET_REGISTRATION_DATA_STATUS,
  RESET_REGISTRATION_DATA_STATUS,
  SET_SIGNUP_LOGIN_TOKEN,
  SET_SOCIAL_LOGIN_FLOW,
  RESET_SOCIAL_LOGIN_FLOW,
  SET_SOCIAL_PHONE_CHECK_TOKEN,
  SET_ANALYTICS_DATA,
  SET_LAST_REGISTRATION_STATUS_CODE,
  SET_REGISTRATION_ERROR,
  SET_ADDRESS_OTP_ERROR,
  SET_ADDRESS_OTP_FLOW,
  SET_OTP_LOGIN_FLOW_BFL,
  SAVE_SOCIAL_ANALYTICS_DATA,
  SAVE_PHONE_FOR_ANALYTICS,
  SET_IS_CONFLICT_MOBILE_FLOW,
  SAVE_UPDATE_DETAILS_DATA
} from "../constants";
import {
  IS_AUTH_FROM_CHECKOUT,
  CHECKOUT_ID,
  SIGNUP_CODES_FOR_MODAL,
  SIGNUP_API_CODE_NAMES,
  SOCIAL_SIGNUP_MODES
} from "../../constants";
import { EMAIL_LOGIN_METHOD } from "../../services/analytics/googleAnalytics/constants";
import {
  AddressService,
  AuthService,
  DynamicYieldEventService,
  GuestService,
  SocialAuthService,
  UserDetailsService
} from "../../services";
import { updateCheckoutById } from "./checkout.action";
import { getCartAndWishlistGeneralData } from "./cart.action";
import AuthAnaltyicsEvent from "../../services/analytics/main/authentication";
import { HeapService } from "../../services/analytics/heap";
import { fetchLoyaltyDetails } from "./myAccount.action";
import { removeCheckoutGuestToken } from "@/util/browserStorage";
import { setAuthEmail } from "@/util/auth";

export const ApiError = content => ({ type: API_ERROR, content });
export const resetAPIError = () => ({ type: RESET_API_ERROR });
export const notificationMsg = message => ({
  type: API_NOTIFICATION_MSG,
  message
});
export const resetnotificationMsg = content => ({
  type: RESET_NOTIFICATION_MSG
});

export const userProfile = data => ({ type: LOGIN_SUCCESS, data });

export const setRegistrationDataStatus = data => ({
  type: SET_REGISTRATION_DATA_STATUS,
  payload: data
});

export const resetRegistrationDataStatus = () => ({
  type: RESET_REGISTRATION_DATA_STATUS
});

export const setSignUpLoginToken = token => ({
  type: SET_SIGNUP_LOGIN_TOKEN,
  payload: token
});

export const setSocialPhoneCheckToken = token => ({
  type: SET_SOCIAL_PHONE_CHECK_TOKEN,
  payload: token
});

export const setSocialLoginFlow = flag => ({
  type: SET_SOCIAL_LOGIN_FLOW,
  payload: flag
});

export const setConflictMobileFlow = flag => ({
  type: SET_IS_CONFLICT_MOBILE_FLOW,
  payload: flag
});

export const setOTPLoginFlowBFL = flag => ({
  type: SET_OTP_LOGIN_FLOW_BFL,
  payload: flag
});

export const resetSocialLoginFlow = () => ({
  type: RESET_SOCIAL_LOGIN_FLOW
});

export const setAnalyticsData = data => ({
  type: SET_ANALYTICS_DATA,
  payload: data
});

export const saveSocialAnalyticsData = data => ({
  type: SAVE_SOCIAL_ANALYTICS_DATA,
  payload: data
});

export const savePhoneForAnalytics = data => ({
  type: SAVE_PHONE_FOR_ANALYTICS,
  payload: data
});

const setLastRegistrationStatusCode = code => ({
  type: SET_LAST_REGISTRATION_STATUS_CODE,
  payload: code
});

const setRegistrationError = data => ({
  type: SET_REGISTRATION_ERROR,
  payload: data
});

export const resetRegistrationError = () => ({
  type: SET_REGISTRATION_ERROR,
  payload: ""
});

const loginCompleteCheckoutFirstStep = () => dispatch => {
  if (localStorage.getItem(IS_AUTH_FROM_CHECKOUT)) {
    const checkoutId = localStorage.getItem(CHECKOUT_ID);
    if (checkoutId) {
      dispatch(
        updateCheckoutById(checkoutId, {
          step1Completed: true,
          continueAsGuest: false
        })
      );
    } else {
      localStorage.removeItem(IS_AUTH_FROM_CHECKOUT);
      localStorage.removeItem(CHECKOUT_ID);
    }
  }
};

export const setAddressOtpError = error => ({
  type: SET_ADDRESS_OTP_ERROR,
  payload: error
});

export const setAddressOtpFlow = flowData => ({
  type: SET_ADDRESS_OTP_FLOW,
  payload: flowData
});

export const authenticateUserByEmail =
  ({ email }) =>
  async dispatch => {
    dispatch(showLoadingIndicator());
    try {
      dispatch(resetResponseUpdateDetailsData());
      const response = await AuthService.authenticateUserByEmail(email);
      setAuthEmail(email);
      dispatch(
        setAuthUserData({
          email,
          token: response.token ?? "",
          code: response.code ?? "",
          signInOptions: response.signInOptions ?? []
        })
      );

      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      const message = error?.response?.data?.message || "";
      throw new Error(message);
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };

export const authenticateUser = ({
  bodyData,
  history,
  language,
  redirect = true,
  country,
  onAuth = null,
  withCartRedirect = false,
  onAuthMissingFieldsError = null
}) => {
  language = languageFromPathName(language);
  const authPath = BEConfig.customerApi.loginUserHandle;
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${authPath}`;
  return async (dispatch, getState) => {
    dispatch(resetResponseUpdateDetailsData());
    dispatch(showLoadingIndicator());
    dispatch(showPageLoader());
    try {
      const response = await postDashboardWebApi(
        getAccessToken(getState),
        apiURL,
        { ...bodyData }
      );
      removeCheckoutGuestToken();
      const isLoginSuccess = isLoginSuccessChecker(response);
      dispatch(
        setAnalyticsData({
          loginFrom: bodyData?.mode || "email"
        })
      );

      if (isLoginSuccess) {
        await handleLoginSuccess({
          dispatch,
          response,
          history,
          language,
          country,
          onAuth,
          withCartRedirect,
          redirect
        });
      } else if (
        response.data?.code === SIGNUP_API_CODE_NAMES.MISSING_FIELDS_REQUIRED
      ) {
        onAuthMissingFieldsError && onAuthMissingFieldsError(response.data);
      } else if (
        response.data?.code === SIGNUP_API_CODE_NAMES.MOBILE_REQUIRED
      ) {
        dispatch(updateRegistrationDataStatusOnLogin(response.data));
        if (
          [
            SOCIAL_SIGNUP_MODES.APPLE,
            SOCIAL_SIGNUP_MODES.FACEBOOK,
            SOCIAL_SIGNUP_MODES.GOOGLE
          ].includes(bodyData?.mode)
        ) {
          onAuthMissingFieldsError &&
            onAuthMissingFieldsError(response.data, true);
        }
      } else {
        dispatch(ApiError(response.data));
        AuthAnaltyicsEvent.loginError({
          method: bodyData?.mode || "email",
          error: response.data?.message || ""
        });
      }

      return response;
    } catch (error) {
      if (error?.response?.data) {
        dispatch(updateRegistrationDataStatusOnLogin(error.response.data));
      } else {
        handleFetchError(error, dispatch);
      }
      return {
        success: false,
        message: error?.response?.data?.message
      };
    } finally {
      dispatch(hideLoadingIndicator());
      dispatch(hidePageLoader());
    }
  };
};

export const verifyAndAuthenticateOtpUser = ({
  code,
  token,
  history,
  language,
  country,
  redirect = true,
  onAuth = null,
  withCartRedirect = false,
  onAuthMissingFieldsError
}) => {
  language = languageFromPathName(language);
  const authPath = BEConfig.customerApi.loginOtpVerify;
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${authPath}`;

  return async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    try {
      const body = { token, otp: code };
      const response = await postDashboardWebApi(
        /* accessToken */ _,
        apiURL,
        body
      );
      removeCheckoutGuestToken();

      dispatch(
        setAnalyticsData({
          loginFrom: "emailOtp"
        })
      );

      const isLoginSuccess = isLoginSuccessChecker(response);

      if (isLoginSuccess) {
        await handleLoginSuccess({
          dispatch,
          response,
          history,
          language,
          country,
          onAuth,
          withCartRedirect,
          redirect
        });
      } else if (
        response.data?.code === SIGNUP_API_CODE_NAMES.MISSING_FIELDS_REQUIRED
      ) {
        onAuthMissingFieldsError && onAuthMissingFieldsError(response.data);
      } else {
        dispatch(ApiError(response.data));
      }

      return response;
    } catch (error) {
      if (error?.response?.data) {
        dispatch(updateRegistrationDataStatusOnLogin(error.response.data));
      } else {
        handleFetchError(error, dispatch);
      }
      return {
        message: error?.response?.data?.message || "",
        success: false
      };
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};

export const handleLoginSuccess = async ({
  dispatch,
  response,
  history,
  language,
  country,
  onAuth = null,
  withCartRedirect = false,
  redirect = true
}) => {
  const store = ContextStorage.store.getState();
  const { analyticsData } = get(store, "homepage", {});
  onAuth && onAuth(response);
  dispatch(setToken(response.data));
  await dispatch(fetchLoyaltyDetails());
  dispatch(loginCompleteCheckoutFirstStep());
  dispatch(userProfile(response.data));
  AuthAnaltyicsEvent.socialSignIn({
    loginFrom: analyticsData.loginFrom,
    responseData: response.data
  });
  const customerId =
    response.data?.customerId || response.data?.userProfile?.customerId;
  if (customerId) HeapService.identify(String(customerId));
  if (!withCartRedirect) {
    await dispatch(getCartAndWishlistGeneralData());
  }
  if (redirect) {
    history.push(`/${language}-${country || "ae"}/`);
  }
};

// Similiar flow will need on the authenticate/complete
export const handleOtpUpdateMandatoryFields = data =>
  updateOTPWithMandatoryFields(data, AuthService.verifyUpdateComplete);

export const handleOtpUpdateMandatoryFieldsAuthorize = data =>
  updateOTPWithMandatoryFields(data, AuthService.verifyUpdateCompleteAuthorize);

export const handleOtpGuestRegistrationMandatoryFields = data =>
  updateOTPWithMandatoryFields(
    data,
    GuestService.verifyOTPRegistration.bind(GuestService),
    true
  );

export const handleOtpUpdateSocialMandatoryFields = data =>
  updateOTPWithMandatoryFields(
    data,
    SocialAuthService.socialRegistrationComplete
  );

const updateOTPWithMandatoryFields = (
  {
    token,
    otp,
    history,
    language,
    country,
    onAuth = null,
    withCartRedirect = false,
    redirect = true
  },
  dataGetter,
  isGuestRegistration = false
) => {
  language = languageFromPathName(language);
  return async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    try {
      const response = await dataGetter({ token, otp });
      const isLoginSuccess = isLoginSuccessChecker(response);
      if (!isGuestRegistration) {
        if (isLoginSuccess) {
          await handleLoginSuccess({
            dispatch,
            response,
            history,
            language,
            country,
            onAuth,
            withCartRedirect,
            redirect
          });
        } else {
          dispatch(ApiError(response.data));
          AuthAnaltyicsEvent.loginError({
            method: bodyData?.mode || "email",
            error: response.data?.message || ""
          });
        }
      } else {
        if (isLoginSuccess)
          history.push(
            `/${language}-${country || "ae"}/registration/thank-you`
          );
      }
      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      return {
        success: false,
        message: error?.response?.data?.message
      };
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};

const provideMissedFieldsData = ({
  bodyData,
  token,
  endpoint,
  loginSuccessData: {
    history,
    language,
    country,
    onAuth = null,
    withCartRedirect = false,
    redirect = true
  }
}) => {
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${endpoint}`;
  return async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    try {
      const response = await postDashboardWebApi(_, apiURL, {
        data: bodyData,
        token
      });

      const isLoginSuccess = isLoginSuccessChecker(response);
      if (isLoginSuccess) {
        await handleLoginSuccess({
          dispatch,
          response,
          history,
          language,
          country,
          onAuth,
          withCartRedirect,
          redirect
        });
      } else {
        dispatch(ApiError(response.data));
        // Probably we need this event ???
        // AuthAnaltyicsEvent.loginError({
        //   method: bodyData?.mode || "email",
        //   error: response.data?.message || ""
        // });
      }
      return response.data;
    } catch (error) {
      handleFetchError(error, dispatch);
      return error;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};

export const handleMandatoryFields = ({
  bodyData,
  token,
  loginSuccessData
}) => {
  const endpoint = BEConfig.customerApi.handleMandatoryFields;
  return provideMissedFieldsData({
    token,
    bodyData,
    endpoint,
    loginSuccessData
  });
};

export const handleMandatorySocialFields = ({
  bodyData,
  token,
  loginSuccessData
}) => {
  const endpoint = BEConfig.customerApi.socialRegistration;
  return provideMissedFieldsData({
    token,
    bodyData,
    endpoint,
    loginSuccessData
  });
};

export const saveAddress = (bodyData, guest) => async (dispatch, getState) => {
  dispatch(showLoadingIndicator());
  let type;
  if (bodyData.collectionPointId === -1) {
    type = "DELIVERY_ADDRESS";
  } else {
    type = getState().checkoutReducer.checkoutData.deliveryType;
  }
  const saveAddressBodyData = {
    ...bodyData,
    deliveryType: type
  };
  const phoneForOTP = saveAddressBodyData.phone;
  try {
    const [initFlow, verifyCall] = bodyData.addressId
      ? [
          AddressService.updateAddress.bind(AddressService),
          AddressService.completeUpdating.bind(AddressService)
        ]
      : [
          AddressService.myAccountAddAddress.bind(AddressService),
          AddressService.completeAdding.bind(AddressService)
        ];

    const response = await initFlow(saveAddressBodyData, guest);

    const otpRequired = response.data.otp_required;
    const countryId = getState().common.settings.countryId;
    if (otpRequired) {
      const tokenForOTPVerification = response.data.token;
      dispatch(
        setAddressOtpFlow({
          phoneForOTP,
          verificationCallback: async otpCode => {
            try {
              const resp = await verifyCall(
                { token: tokenForOTPVerification, otp: otpCode },
                saveAddressBodyData.addressId
              );

              if (!resp.data.success) {
                dispatch(setAddressOtpError(resp.data.message));
                return resp;
              }

              dispatch(fetchAddressBook(countryId));
              return resp;
            } catch (error) {
              if (errorOnUserSide(error.response.status)) {
                dispatch(setAddressOtpError(error.response.data.message));
                return error.response;
              }
            }
          },
          resendOTPCallback: async () => {
            try {
              const resp = await AddressService.resendOtp(
                tokenForOTPVerification
              );

              if (!resp.data.success) {
                dispatch(setAddressOtpError(resp.data.message));
                return resp;
              }

              return resp;
            } catch (error) {
              if (errorOnUserSide(error.response.status)) {
                dispatch(setAddressOtpError(error.response.data.message));
                return error.response;
              }
            }
          }
        })
      );
      return {
        OTPNeeded: true
      };
    }
    if (response.status === 200 && response.data && response.data.success) {
      dispatch(fetchAddressBook(countryId));
      return response;
    } else {
      dispatch(ApiError(response.data));
    }
    internalServerError(response, dispatch); //api internal server error
    return response;
  } catch (error) {
    if (errorOnUserSide(error.response.status)) {
      dispatch(
        setAddressOtpFlow({ phoneForOTP, error: error.response.data.message })
      );
      return {
        OTPNeeded: true
      };
    }

    handleFetchError(error, dispatch);
    return error.response;
  } finally {
    dispatch(hideLoadingIndicator());
  }
};

export const resetPasswordEmailLink = bodyData => {
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${BEConfig.customerApi.resetEmailLinkHandle}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    return putDashboardWebApi(null, apiURL, bodyData)
      .then(response => {
        dispatch(hideLoadingIndicator());
        if (response.status === 200 && response.data && response.data.success) {
          dispatch(notificationMsg(response.data.message));
        } else {
          dispatch(ApiError(response.data));
        }
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const resetPasswordAPI = (bodyData, history, language, country) => {
  language = languageFromPathName(language);
  const apiURL = `${BEConfig.customerApi.protocol}${BEConfig.customerApi.baseURL}${BEConfig.customerApi.port}${BEConfig.customerApi.versionInfo}${BEConfig.customerApi.resetPasswordHandle}`;
  return (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    return putDashboardWebApi(getAccessToken(getState), apiURL, bodyData)
      .then(response => {
        dispatch(hideLoadingIndicator());
        if (response.status === 200 && response.data && response.data.success) {
          if (history)
            history.push({
              pathname: `/${language}-${
                country || "ae"
              }/registration/thank-you/`,
              state: { detail: "fromResetPassword" }
            });
        } else {
          dispatch(ApiError(response.data));
        }
        return response;
      })
      .catch(error => {
        dispatch(hideLoadingIndicator());
        handleFetchError(error, dispatch);
        return error.response;
      });
  };
};

export const updateUserPassword = bodyData => {
  return async dispatch => {
    dispatch(showLoadingIndicator());
    try {
      const response = await UserDetailsService.updateCurrentPassword(bodyData);
      if (
        !(response.status === 200 && response.data && response.data.success)
      ) {
        dispatch(ApiError(response.data));
      }
      return response;
    } catch (err) {
      handleFetchError(err, dispatch);
      return err.response;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };
};

const passDataToAuthService = async ({
  dispatch,
  data,
  authMethod,
  callBackOnSuccess,
  updateStatus = false
}) => {
  dispatch(showLoadingIndicator());
  try {
    const response = await authMethod(data);
    const { token, code } = response;
    checkForRegistrationErrors(response, data);
    dispatch(setRegistrationDataStatus(response));
    if (token) {
      dispatch(setSignUpLoginToken(token));
    }
    if (code) {
      dispatch(setLastRegistrationStatusCode(code));
    }
    callBackOnSuccess && callBackOnSuccess(response);
    return response;
  } catch (error) {
    if (updateStatus && error?.response?.data) {
      dispatch(updateRegistrationDataStatusOnLogin(error.response.data));
    } else if (error?.response?.status === 403) {
      dispatch(setRegistrationError(error.response?.data?.message));
    } else {
      handleFetchError(error, dispatch);
    }
    return error.response;
  } finally {
    dispatch(hideLoadingIndicator());
  }
};
export const getUserDataStatus = data => async dispatch =>
  passDataToAuthService(dispatch, data, AuthService.getRegistrationStatus); // this method should be deleted due to the new reciproci requirments

export const checkMobileStatus = data => async dispatch =>
  passDataToAuthService(dispatch, data, SocialAuthService.checkMobileStatus); // this method should be deleted due to the new reciproci requirments

export const startRegistration = data => async dispatch =>
  passDataToAuthService({
    dispatch,
    data,
    authMethod: AuthService.startRegistration,
    updateStatus: true
  });

// New action for initiating mobile number verification
export const initiateMobileVerification =
  token => async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    try {
      const response = await AuthService.initiateMobileVerification({ token });
      dispatch(updateRegistrationDataStatusOnLogin(response));
      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      dispatch(updateRegistrationDataStatusOnLogin(error.response.data));
      return error;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };

// New action for completing mobile number verification with OTP
export const completeMobileVerification =
  ({ token, otp }) =>
  async (dispatch, getState) => {
    dispatch(showLoadingIndicator());
    try {
      const response = await AuthService.completeMobileVerification({
        token,
        otp
      });
      return response;
    } catch (error) {
      handleFetchError(error, dispatch);
      dispatch(setRegistrationError(error.response?.data?.message));
      return error.response;
    } finally {
      dispatch(hideLoadingIndicator());
    }
  };

const checkForRegistrationErrors = (response, data) => {
  const { code, message = "" } = response;
  const store = ContextStorage.store.getState();
  const { analyticsData, socialLoginFlow } = get(store, "homepage", {});
  if (code && !SIGNUP_CODES_FOR_MODAL[code] && !response?.success) {
    // if Social login flow Errors
    if (socialLoginFlow && analyticsData?.loginFrom) {
      AuthAnaltyicsEvent.loginError({
        method: analyticsData?.loginFrom,
        error: message || ""
      });
    } else {
      // if normal Sign In/Up flow Errors
      const gaPayload = { method: EMAIL_LOGIN_METHOD, error: message || "" };
      if (data.email && data.isAgeVerified) {
        // To Check for Signup flow.
        AuthAnaltyicsEvent.signUpError(gaPayload);
      } else {
        AuthAnaltyicsEvent.loginError(gaPayload);
      }
    }
  }
};

export const isLoginSuccessChecker = response => {
  return (
    response.status === 200 &&
    response.data &&
    response.data.success &&
    (!response.data.code ||
      response.data.code === 200 ||
      response.data.code === "200")
  );
};

const passDataToAnalytics = (response, registrationData, getState) => {
  const store = getState();
  const { socialLoginFlow } = get(store, "homepage", {});
  const customerId = get(response, "customerId", "");
  const country = get(store, "common.settings.countryCode");
  const countryData = get(store, "common.countryData");
  const countryId = get(store, "common.settings.countryId");
  const { countryName } =
    countryData.find(countryData => countryData.countryId === countryId) || {};
  AuthAnaltyicsEvent.signUp({
    isSocialLogin: socialLoginFlow,
    customerId: customerId,
    registerData: registrationData
  });
  DynamicYieldEventService.signUp(get(registrationData, "email", ""));
};

export const verifyReceivedOtp =
  (credentials, registrationData) => async (dispatch, getState) => {
    const store = getState();
    const {
      socialLoginFlow,
      analyticsData,
      otpLoginFlowBFL,
      socialAnalyticsData
    } = get(store, "homepage", {});
    return passDataToAuthService(
      dispatch,
      credentials,
      (socialLoginFlow ? SocialAuthService : AuthService).completerRegistration,
      response => {
        if (response.success) {
          dispatch(loginCompleteCheckoutFirstStep());
          if (!otpLoginFlowBFL) {
            const data = socialLoginFlow
              ? { ...analyticsData, ...socialAnalyticsData }
              : registrationData;
            passDataToAnalytics(response, data, getState);
            dispatch(saveSocialAnalyticsData({}));
          }
        }
      }
    );
  };

export const getUsedAccounts = data => async (dispatch, getState) => {
  const store = getState();
  const { socialLoginFlow } = get(store, "homepage", {});
  return passDataToAuthService(
    dispatch,
    data,
    (socialLoginFlow ? SocialAuthService : AuthService)
      .deactivatePreviousAccounts
  );
};

export const deactivatePreviousAccounts =
  (credentials, registrationData) => async (dispatch, getState) => {
    const store = getState();
    const { socialLoginFlow } = get(store, "homepage", {});
    return passDataToAuthService(
      dispatch,
      credentials,
      (socialLoginFlow ? SocialAuthService : AuthService).completerRegistration,
      response => {
        if (response.success) {
          dispatch(loginCompleteCheckoutFirstStep());
          passDataToAnalytics(response, registrationData, getState);
        }
      }
    );
  };

export const loginAndFetchUser = response => async (dispatch, getState) => {
  const store = getState();
  const { otpLoginFlowBFL } = store.homepage;
  let { analyticsData } = store.homepage;

  dispatch(userProfile(response));
  dispatch(setToken(response));
  dispatch(fetchUserAndLoadData());

  if (!otpLoginFlowBFL) {
    // Social auto login after user registeration through social
    AuthAnaltyicsEvent.socialSignIn({
      loginFrom: analyticsData.loginFrom,
      responseData: response
    });
    DynamicYieldEventService.login(response.email);
  }
};

export const updateRegistrationDataStatusOnLogin = response => dispatch => {
  const { token, code } = response;
  dispatch(setRegistrationDataStatus(response));
  if (token) {
    dispatch(setSocialPhoneCheckToken(token));
    dispatch(setSignUpLoginToken(token));
  }
  if (code) {
    dispatch(setLastRegistrationStatusCode(code));
  }
};
